export const worksheetEmailTemplateVariables = [
  { token: '{{worksheetId}}', description: 'Munkalap azonosítója' },
  { token: '{{worksheetName}}', description: 'Munkalap neve' },
  { token: '{{projectName}}', description: 'Projekt neve' },
  { token: '{{projectOrderNumber}}', description: 'Projekt rendelési száma' },
  { token: '{{userName}}', description: 'Küldő felhasználó neve' },
  { token: '{{userEmail}}', description: 'Küldő felhasználó e-mail címe' },
];
